module.exports = __webpack_public_path__ + "img/jitsi-logo.3936f616.png";